export default __webpack_public_path__ + "static/media/32.5123d3a2.png";